/* eslint-disable */
/**
 * Select the currently logged in auth
 * @param {any} state The state management `state`
 * @returns {AuthEntity | null} The `auth` that have been selected from the store
 */
const authCurrentSelector = (state) => state.auth.entities[state.auth.selectedIds[0]] || null;

export default authCurrentSelector;
